export const GET_EXAM_RESULTS_LISTING = '/results';
export const GET_EXAM_RESULTS = '/results';
export const POST_AUDIT_VIEW_RESULT = '/audit/view-result';
export const POST_START_RESIT = '/resit';
export const POST_AUDIT_APPLY_RESIT = '/audit/apply-resit';
